import { render, staticRenderFns } from "./cfPlanCheck.vue?vue&type=template&id=21e1887f&scoped=true"
import script from "./cfPlanCheck.vue?vue&type=script&lang=js"
export * from "./cfPlanCheck.vue?vue&type=script&lang=js"
import style0 from "./cfPlanCheck.vue?vue&type=style&index=0&id=21e1887f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1887f",
  null
  
)

export default component.exports